import {
  mdiEye,
  mdiDelete,
  mdiDownload,
  mdiPaperclip,
  mdiFile,
  mdiEmail,
  mdiFilePdfBox,
  mdiZipBox,
  mdiFileJpgBox,
  mdiFilePngBox,
  mdiFilePowerpointBox,
  mdiFileWordBox,
  mdiFileExcelBox,
  mdiFileDelimited,
  mdiVideo
} from '@mdi/js'

export default {
  'freshvuefiles-show': mdiEye,
  'freshvuefiles-delete': mdiDelete,
  'freshvuefiles-download': mdiDownload,

  'freshvuefiles-file': mdiPaperclip,
  'freshvuefiles-file-default': mdiFile,
  'freshvuefiles-file-email': mdiEmail,
  'freshvuefiles-file-application/pdf': mdiFilePdfBox,
  'freshvuefiles-file-application/zip': mdiZipBox,
  'freshvuefiles-file-image/jpeg': mdiFileJpgBox,
  'freshvuefiles-file-image/png': mdiFilePngBox,
  'freshvuefiles-file-application/ms-powerpoint': mdiFilePowerpointBox,
  'freshvuefiles-file-application/msword': mdiFileWordBox,
  'freshvuefiles-file-application/msexcel': mdiFileExcelBox,
  'freshvuefiles-file-text/csv': mdiFileDelimited,
  'freshvuefiles-file-video/mp4': mdiVideo
}
